var map = {
	"./l-1.png": "461a",
	"./l-2.png": "b4de",
	"./l-3.png": "e789",
	"./l-4.png": "113b",
	"./p-1.png": "2fca",
	"./p-2.png": "a13f",
	"./p-3.png": "ed54",
	"./p-4.png": "497a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "37684";